import { render, staticRenderFns } from "./FotoClienteRural.vue?vue&type=template&id=8ecf31bc&scoped=true"
import script from "./FotoClienteRural.vue?vue&type=script&lang=js"
export * from "./FotoClienteRural.vue?vue&type=script&lang=js"
import style0 from "./FotoClienteRural.vue?vue&type=style&index=0&id=8ecf31bc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecf31bc",
  null
  
)

export default component.exports